import { Component, Input, OnInit } from '@angular/core';

import { of, catchError, tap } from 'rxjs';

import { PricePlan } from '@shared/price-plan/models';
import { SubscriptionService } from '../../services';
import { FrontendModalService } from '@tablesready/frontend-modal';
import { AlertsService } from '@tablesready/frontend-alerts-bar';

@Component({
  selector: 'confirm-free-trial',
  templateUrl: './confirm-free-trial.component.html',
})
export class ConfirmFreeTrialComponent implements OnInit {
  @Input() pricePlan: PricePlan;
  @Input() isNotUsaOrCanadaRestaurant: boolean;
  @Input() timezone: string;
  @Input() onClose?: () => void;

  inProgress = false;
  freeTrialMessagesLimit: number;
  private get defaultMessagesLimit() {
    return 150;
  }

  constructor(
    readonly modalController: FrontendModalService,
    private readonly alertsService: AlertsService,
    private readonly subscriptionService: SubscriptionService,
  ) {}

  ngOnInit(): void {
    this.freeTrialMessagesLimit = this.isNotUsaOrCanadaRestaurant ? Math.ceil(this.defaultMessagesLimit * 0.1) : this.defaultMessagesLimit;
  }

  close(): void {
    this.inProgress = false;
    this.modalController.dismiss();
    if (typeof this.onClose === 'function') {
      this.onClose();
    }
  }

  confirm(): void {
    this.inProgress = true;

    this.subscriptionService.subscribe({ plan: this.pricePlan.plan_code })
      .pipe(
        tap(() => {
          this.alertsService.addSuccess(
            'Trial subscription created. Thanks for subscribing!',
            'Success:',
          );
          this.close();
        }),
        catchError((err) => {
          this.alertsService.addError(
            err.message,
            'Error:',
          );
          this.close();

          return of();
        }),
      )
      .subscribe();
  }
}
